import React from "react";
import { process } from "@progress/kendo-data-query";
import { SpheraSubTab, SpheraTab } from "@sphera-cloud/component-ui-reactjs";
import { Menu, MenuItem } from "@progress/kendo-react-layout";
import { Popup } from "@progress/kendo-react-popup";
import { DocumentDetailsGrid } from "../components/Grid/DocumentDetailsGrid";
import { Layout } from "../components/MasterPage/Layout";
import { DocumentModal } from "../components/Modals/DocumentModal";
import { MaterialSynoymsModal } from "../components/Modals/MaterialSynoymsModal";
import { EditTagsModal } from "../components/Modals/EditTagsModal";
import { ChangeDocumentSensitivityModal } from "../components/Modals/ChangeDocumentSensitivityModal";
import { DeleteDocumentsModal } from "../components/Modals/DeleteDocumentsModal";
import { ArchiveDocumentsModal } from "../components/Modals/ArchiveDocumentsModal";
import { UnArchiveDocumentsModal } from "../components/Modals/UnArchiveDocumentsModal";
import useFetchWithMsal from "../services/useFetchWithMsal";
import { apiRoutes } from "../services/apiRoutes";
import { cookieHandler } from "../services/cookieHandler";
import { MaterialDetails } from "../components/MaterialDetails"
import { MaterialHeader } from "../components/MaterialHeader"
import { MaterialData } from "../Data/MaterialData"

export function Material(props) {
    const { setCookie, getCookie } = cookieHandler();

    let documentGridSettingsJSON = getCookie("SpheraDocumentFilterStatus");
    let statusTemp = false;
    if (documentGridSettingsJSON != null && documentGridSettingsJSON !== "") {
        statusTemp = documentGridSettingsJSON === "true";
    }

    const hrefParts = window.location.href.split("/");
    const MaterialId = hrefParts[hrefParts.length - 1].replace("?fromSearch=true", "").replace("&searchArchive=true", "").replace("?searchArchive=true", "");
    const [materialData, setmaterialData] = React.useState({});
    const [success, setsuccess] = React.useState(false);
    const [error, seterror] = React.useState(false);
    const [checkAllChecked, setcheckAllChecked] = React.useState(false);
    const [errorMessage, seterrorMessage] = React.useState("");
    const [selectedDoc, setselectedDoc] = React.useState({ Ingredients: [] });
    const [isDelete, setisDelete] = React.useState(false);
    const [showEditTags, setshowEditTags] = React.useState(false);
    const [tagsValue, settagsValue] = React.useState([]);
    const [tagsOptions, settagsOptions] = React.useState([]);

    const urlParams = new URLSearchParams(window.location.search);
    let sArch = urlParams.get('searchArchive');
    if (sArch == null || !props.currentTenent.IsViewArchivedDocumentsUser)
        sArch = false;
    const [searchArchive, setsearchArchive] = React.useState(sArch);

    // Configurable Material Header fields, in display order: primary (always materialName),
    // then the configured secondary and tertiary columns. Each entry: { field, label, isList }.
    const [headerFields, setheaderFields] = React.useState([]);

    const [standardIngredients, setstandardIngredients] = React.useState([]);
    const [standardDataState, setstandardDataState] = React.useState({ skip: 0, take: 25 });
    const [standardDataResult, setstandardDataResult] = React.useState(
        process([], { skip: 0, take: 25 })
    );
    const [fullIngredients, setfullIngredients] = React.useState([]);
    const [fullDataState, setfullDataState] = React.useState({ skip: 0, take: 25 });
    const [fullDataResult, setfullDataResult] = React.useState(
        process([], { skip: 0, take: 25 })
    );

    const [transportation, settransportation] = React.useState([]);
    const [transportationDataState, settransportationDataState] = React.useState({ skip: 0, take: 25 });
    const [transportationDataResult, settransportationDataResult] = React.useState(
        process([], { skip: 0, take: 25 })
    );

    const standardDataStateChange = (event) => {
        setstandardDataResult(process(standardIngredients, event.dataState));
        setstandardDataState(event.dataState);
    };
    const fullDataStateChange = (event) => {
        setfullDataResult(process(fullIngredients, event.dataState));
        setfullDataState(event.dataState);
    };

    const transportationDataStateChange = (event) => {
        setfullDataResult(process(fullIngredients, event.dataState));
        setfullDataState(event.dataState);
    };

    const [phraseSections, setphraseSections] = React.useState([]);
    const [phraseSectionsSelected, setphraseSectionsSelected] = React.useState([]);
    const [sectionsDropdownData, setsectionsDropdownData] = React.useState([]);

    const [originalDocuments, setoriginalDocuments] = React.useState([]);
    const [documents, setdocuments] = React.useState([]);
    const [dataState, setDataState] = React.useState({ skip: 0, take: 25 });
    const [pending, setPending] = React.useState(false);
    const [modalPending, setmodalPending] = React.useState(false);
    const [documentLink, setDocumentLink] = React.useState("");
    const [changeSensitivityValue, setchangeSensitivityValue] = React.useState("1");
    const [showSynsModal, setshowSynsModal] = React.useState(false);
    const [showSensitivityModal, setshowSensitivityModal] = React.useState(false);
    const [showDeleteDocumentsModal, setshowDeleteDocumentsModal] = React.useState(false);
    const [showArchiveDocumentsModal, setshowArchiveDocumentsModal] = React.useState(false);
    const [showUnArchiveDocumentsModal, setshowUnArchiveDocumentsModal] = React.useState(false);
    const [synonyms, setsynonyms] = React.useState([]);
    const [sectionsTree, setsectionsTree] = React.useState([]);
    const showSynonymsModal = () => { setshowSynsModal(!showSynsModal); }
    const toggleSensitivity = () => {
        let selected = documents.filter(x => x.selected);

        if (selected.length > 0)
            setshowSensitivityModal(!showSensitivityModal);
    }

    const toggleDeleteDocuments = () => {
        let selected = documents.filter(x => x.selected);

        if (selected.length > 0)
            setshowDeleteDocumentsModal(!showDeleteDocumentsModal);
    }

    const toggleArchiveDocuments = () => {
        let selected = documents.filter(x => x.selected);

        if (selected.length > 0)
            setshowArchiveDocumentsModal(!showArchiveDocumentsModal);
    }

    const toggleUnArchiveDocuments = () => {
        let selected = documents.filter(x => x.selected);

        if (selected.length > 0)
            setshowUnArchiveDocumentsModal(!showUnArchiveDocumentsModal);
    }

    const toggleEditTags = (deleteVal) => {
        let docTags = documents.filter(x => x.selected).map(y => y.documentTags);
        let tags = [];
        docTags.forEach(x => {
            tags = tags.concat(x);
        });
        let tagsUnique = [...new Set(tags)];
        settagsOptions(tagsUnique);
        settagsValue([]);
        setisDelete(deleteVal);
        setshowEditTags(!showEditTags);
    };

    const changeTagsValue = (e) => {
        if (isDelete) {
            let tags = tagsValue;
            if (e.value) {
                tags.push(e.target.element.labels[0].textContent);
            }
            else {
                const index = tags.indexOf(e.target.element.labels[0].textContent);
                if (index > -1)
                    tags.splice(index, 1);
            }
            settagsValue(tags);
        }
        else {
            settagsValue(e);
        }
    };

    const offSet = React.useRef({
        left: 0,
        top: 0,
    });
    const [show, setShow] = React.useState(false);
    const handleContextMenu = (e) => {
        e.preventDefault();
        offSet.current = {
            left: e.clientX,
            top: e.clientY,
        };
        setShow(true);
    };

    const documentsMenuClick = (e) => {
        if (e.item.text === props.localizations.DeleteDocuments)
            toggleDeleteDocuments();
        else if (e.item.text === props.localizations.ArchiveDocuments)
            toggleArchiveDocuments();
        else if (e.item.text === props.localizations.UnarchiveDocuments)
            toggleUnArchiveDocuments();
        else if (e.item.text === props.localizations.DeleteTags)
            toggleEditTags(true);
        else if (e.item.text === props.localizations.AddTags)
            toggleEditTags(false);
        else
            toggleSensitivity();
    }

    const [pictograms, setpictograms] = React.useState([]);
    const [dataResult, setDataResult] = React.useState(
        process(documents, dataState)
    );
    const dataStateChange = (event) => {
        setDataResult(process(documents, event.dataState));
        setDataState(event.dataState);
    };

    const { execute, result } = useFetchWithMsal({
        scopes: props.loginConfig.protectedResources.apiDocumentList.scopes.read,
    });

    const { getMaterial, getCorrectLocalization, getDocumentData, editTags } = MaterialData({ execute, localizations: props.localizations, searchArchive, customer: props.customer, languageValue: props.languageValue });

    const [showModal, setshowModal] = React.useState(false);

    const checkboxChange = (documentId, checked) => {
        let newDocuments = documents;
        newDocuments.find(x => x.documentId === documentId).selected = checked;

        setoriginalDocuments(newDocuments);
        setdocuments(newDocuments);
        setDataResult(process(newDocuments, dataState));
    };

    const submitEditTags = async () => {
        if (tagsValue == null || tagsValue.length === 0)
            return;
        try {
            setPending(true);
            setshowEditTags(!showEditTags);
            let ids = documents.filter(x => x.selected).map(y => y.documentId);

            let tagsUnique = [...new Set(tagsValue)];
            await editTags(ids, tagsUnique, isDelete);
            setPending(false);
            setcheckAllChecked(false);
            setsuccess(true);
            setTimeout(function () {
                getData();
                setsuccess(false);
            }, 5000);
        }
        catch (err) {
            seterrorMessage(err);
            seterror(true);
            setPending(false);
        }
    };

    const checkAllChange = () => {
        let newDocuments = documents;
        newDocuments.forEach(x => {
            dataResult.data.forEach(y => {
                if (x.documentId === y.documentId)
                    x.selected = !checkAllChecked;
            });
        });

        setoriginalDocuments(newDocuments);
        setdocuments(newDocuments);
        setDataResult(process(newDocuments, dataState));
        setcheckAllChecked(!checkAllChecked);
    };

    const submitChangeDocumentSensitivity = () => {
        let DocumentIds = documents.filter(x => x.selected).map(y => y.documentSourceId);

        setmodalPending(true);
        let postData = {
            sensitivity: changeSensitivityValue,
            materialId: MaterialId,
            DocumentSourceIds: DocumentIds
        };

        execute("PATCH", apiRoutes.documents.patch, postData)
            .then((json) => {
                if (json != null) {
                    setmodalPending(false);
                    setshowSensitivityModal(false);
                    setcheckAllChecked(false);
                    setsuccess(true);
                    setTimeout(function () {
                        getData();
                        setsuccess(false);
                    }, 5000);
                }
            })
            .catch((err) => {
                seterrorMessage(err);
                seterror(true);
            });
    }

    const submitDeleteDocuments = () => {
        let DocumentIds = documents.filter(x => x.selected).map(y => y.documentId);

        setmodalPending(true);
        let postData = DocumentIds.join(",");

        execute("POST", apiRoutes.documents.deleteDoc, postData)
            .then((json) => {
                if (json != null) {
                    setmodalPending(false);
                    setshowDeleteDocumentsModal(false);
                    if (json === true) {
                        setcheckAllChecked(false);
                        setsuccess(true);
                        setTimeout(function () {
                            getData();
                            setsuccess(false);
                        }, 5000);
                    } else {
                        seterrorMessage(props.localizations.DeleteDocumentsError);
                        seterror(true);
                    }
                }
            })
            .catch((err) => {
                seterrorMessage(err);
                seterror(true);
            });
    }

    const submitArchiveDocuments = () => {
        let DocumentIds = documents.filter(x => x.selected).map(y => y.documentId);

        setmodalPending(true);
        let postData = DocumentIds.join(",");

        execute("POST", apiRoutes.documents.archiveDoc, postData)
            .then((json) => {
                if (json != null) {
                    setmodalPending(false);
                    setshowArchiveDocumentsModal(false);
                    if (json === true) {
                        setcheckAllChecked(false);
                        setsuccess(true);
                        setTimeout(function () {
                            getData();
                            setsuccess(false);
                        }, 5000);
                    } else {
                        seterrorMessage(props.localizations.ArchiveDocumentsError);
                        seterror(true);
                    }
                }
            })
            .catch((err) => {
                seterrorMessage(err);
                seterror(true);
            });
    }
    const submitUnArchiveDocuments = () => {
        let DocumentIds = documents.filter(x => x.selected).map(y => y.documentId);

        setmodalPending(true);
        let postData = DocumentIds.join(",");

        execute("POST", apiRoutes.documents.unArchiveDoc, postData)
            .then((json) => {
                if (json != null) {
                    setmodalPending(false);
                    setshowUnArchiveDocumentsModal(false);
                    setcheckAllChecked(false);
                    setsuccess(true);
                    setTimeout(function () {
                        getData();
                        setsuccess(false);
                    }, 5000);
                }
            })
            .catch((err) => {
                seterrorMessage(err);
                seterror(true);
            });
    }

    const toggle = (documentName) => {
        if (documentName.indexOf == null || documentName.indexOf(".pdf") > 0)
            setshowModal(!showModal);

        if (!showModal) {
            setPending(true);
            getDocumentData(documentName, materialData, phraseSections).then((data) => {
                setpictograms(data.pictograms);
                setstandardIngredients(data.standardIngredients);
                setfullIngredients(data.fullIngredients);
                setstandardDataResult(process(data.standardIngredients, { skip: 0, take: 25 }));
                setstandardDataState({ skip: 0, take: 25 });
                setfullDataResult(process(data.fullIngredients, { skip: 0, take: 25 }));
                setfullDataState({ skip: 0, take: 25 });
                settransportation(data.document.transportation);
                settransportationDataResult(process(data.document.transportation, { skip: 0, take: 25 }));
                settransportationDataState({ skip: 0, take: 25 });
                setsectionsTree(data.tree);
                setsectionsDropdownData(JSON.parse(JSON.stringify(data.tree)));
                setphraseSectionsSelected(JSON.parse(JSON.stringify(data.tree)));
                setselectedDoc(data.document);
                setDocumentLink(data.link);
                setPending(false);
            });
        }
    };

    const handlePhrasesDropdownChange = (e) => {
        let newphraseSections = phraseSections;
        let newsectionsDropdownData = sectionsDropdownData;
        newsectionsDropdownData.forEach(x => {
            x.show = false;
        });
        e.value.forEach(x => {
            let phrase = newsectionsDropdownData.find(y => x.value === y.value);
            if (phrase)
                phrase.show = true;
        });

        newphraseSections.forEach(x => {
            if (x.phraseSectionType.parentPhraseSectionTypeId == null)
                x.show = false;
        });
        e.value.forEach(x => {
            let phrase = newphraseSections.find(y => x.phraseSectionId === y.phraseSectionId);
            if (phrase)
                phrase.show = true;
        });
        let phrases = e.value;
        setphraseSectionsSelected(phrases);
        setphraseSections(newphraseSections);
        setsectionsDropdownData(newsectionsDropdownData);
    };

    const [status, setStatus] = React.useState(statusTemp);

    const handleStatusChange = () => {
        let filteredDocs = originalDocuments;
        if (status)
            filteredDocs = filteredDocs.filter(x => x.status === 1 || x.status === 4);

        setCookie("SpheraDocumentFilterStatus", !status);
        setStatus(!status);

        setdocuments(filteredDocs);
        setDataResult(process(filteredDocs, dataState));
    }

    const getData = async () => {
        setPending(true);

        let results = await getMaterial(MaterialId, status);

        setmaterialData(results.materialData);
        setoriginalDocuments(results.newDocuments);
        setdocuments(results.filteredDocs);
        setDataResult(process(results.filteredDocs, dataState));
        setphraseSections(results.phraseSections);
        setsynonyms(results.synonyms);
        setPending(false);
    };

    const [gotData, setgotData] = React.useState(false);
    React.useEffect(() => {
        if (props.localizations.Search == null || result == null || gotData)
            return;

        setgotData(true);
    }, [props.localizations.Search, result]);

    React.useEffect(() => {
        if (gotData)
            getData();
    }, [gotData]);

    const popupClick = (e) => {
        if (show && (e.target.className !== 'icon-ui-general-settings icon l-icon' && e.target.className !== "k-button k-button-md k-button-solid k-button-solid-base k-rounded-md  btn-primary")) {
            setShow(false);
        }
    }

    React.useEffect(() => {
        document.removeEventListener('click', popupClick);
        document.addEventListener("click", popupClick);
    }, [show]);

    React.useEffect(() => {
        let data = materialData;
        data.materialName = getCorrectLocalization(data.synonyms, props.languageValue.languageCode, false, false);
        data.chemicalName = getCorrectLocalization(data.synonyms, props.languageValue.languageCode, true, false);
        data.manufacturer = getCorrectLocalization(data.synonyms, props.languageValue.languageCode, false, true) ?? data.manufacturer;

        setmaterialData(data);

        if (props.customer != null && props.customer.columns) {
            if ((((props.currentTenent.IsEditSensitivityUser || props.currentTenent.IsDeleteDocumentsUser) && !searchArchive) || (props.currentTenent.IsManageArchivedDocumentsUser) || (props.currentTenent.IsEditTagsUser)) && props.customer.columns.documentColumns[0].field !== "selected")
                props.customer.columns.documentColumns.unshift({
                    "Title": "SelectRow",
                    "field": "selected",
                    "show": true,
                    "IsCheckbox": true,
                    "noFilterOrSort": true,
                    "AlwaysShow": true,
                    "ExcludeFromExport": true,
                    "order": -1
                });

            let matColumns = props.customer.columns.materialColumns;
            const toHeaderField = (col) => col == null ? null : { field: col.field, label: col.Title, isList: col.IsList === "true" };

            let primaryCol = matColumns.find(x => x.field === "materialName");
            let secondaryCol = props.customer.SecondaryHeaderColumnId != null ? matColumns.find(x => x.columnId === props.customer.SecondaryHeaderColumnId) : null;
            let tertiaryCol = props.customer.TertiaryHeaderColumnId != null ? matColumns.find(x => x.columnId === props.customer.TertiaryHeaderColumnId) : null;

            setheaderFields([toHeaderField(primaryCol), toHeaderField(secondaryCol), toHeaderField(tertiaryCol)].filter(Boolean));
        }
    }, [props.localizations]);

    return (
        <Layout versionNumber={props.versionNumber} errorMessage={errorMessage} localizations={props.localizations}
            languageValue={props.languageValue} currentTenent={props.currentTenent} success={success} setSuccess={setsuccess}
            error={error} setError={seterror}>
            <MaterialHeader materialData={materialData} localizations={props.localizations} headerFields={headerFields} searchArchive={searchArchive} />
            <div className="materialDetailsTab">
                <SpheraTab>
                    <SpheraSubTab title={searchArchive ? props.localizations.ArchiveDocuments : props.localizations.Documents} >
                        <div>
                            {gotData && <DocumentDetailsGrid
                                localizations={props.localizations}
                                pending={pending}
                                documents={documents}
                                dataState={dataState}
                                dataResult={dataResult}
                                materialData={materialData}
                                dataStateChange={dataStateChange}
                                toggle={toggle}
                                handleStatusChange={handleStatusChange}
                                status={status}
                                customer={props.customer}
                                checkboxChange={checkboxChange}
                                checkAllChange={checkAllChange}
                                toggleSensitivity={toggleSensitivity}
                                checkAllChecked={checkAllChecked}
                                currentTenent={props.currentTenent}
                                handleContextMenu={handleContextMenu}
                                searchArchive={searchArchive}
                                dateFormatId={props.customer.DateFormatId}
                            />}
                        </div>
                    </SpheraSubTab>
                    <SpheraSubTab title={props.localizations.MaterialDetails} >
                        <MaterialDetails showSynonymsModal={showSynonymsModal} materialData={materialData} localizations={props.localizations} customer={props.customer} headerFields={headerFields} />
                    </SpheraSubTab>
                </SpheraTab>
            </div>
            <Popup show={show} offset={offSet.current} >
                <Menu
                    vertical={true}
                    style={{
                        display: "inline-block",
                        padding: "5px",
                    }}
                    popupAlign={{ horizontal: "left"}}
                    onSelect={documentsMenuClick}
                >
                    {(props.currentTenent.IsEditSensitivityUser && !searchArchive) &&
                        <MenuItem text={props.localizations.ChangeSensitivity} />
                    }
                    {(props.currentTenent.IsDeleteDocumentsUser && !searchArchive) &&
                        <MenuItem text={props.localizations.DeleteDocuments} />
                    }
                    {(props.currentTenent.IsManageArchivedDocumentsUser && !searchArchive) &&
                        <MenuItem text={props.localizations.ArchiveDocuments} />
                    }
                    {(props.currentTenent.IsManageArchivedDocumentsUser && searchArchive) &&
                        <MenuItem text={props.localizations.UnarchiveDocuments} />
                    }
                    {(props.currentTenent.IsEditTagsUser && !searchArchive) &&
                        <MenuItem text={props.localizations.AddTags} />
                    }
                    {(props.currentTenent.IsEditTagsUser && !searchArchive) &&
                        <MenuItem text={props.localizations.DeleteTags} />
                    }
                </Menu>
            </Popup>
            <DocumentModal
                localizations={props.localizations}
                pending={pending}
                toggle={toggle}
                showModal={showModal}
                documentLink={documentLink}
                selectedDoc={selectedDoc}
                documentColumns={props.customer.columns == null ? null : props.customer.columns.documentColumns}
                standardDataStateChange={standardDataStateChange}
                standardDataState={standardDataState}
                standardDataResult={standardDataResult}
                standardIngredients={standardIngredients}
                fullDataStateChange={fullDataStateChange}
                fullDataState={fullDataState}
                fullDataResult={fullDataResult}
                fullIngredients={fullIngredients}
                customer={props.customer}
                sectionsTree={sectionsTree}
                languageValue={props.languageValue}
                handlePhrasesDropdownChange={handlePhrasesDropdownChange}
                phraseSectionsSelected={phraseSectionsSelected}
                sectionsDropdownData={sectionsDropdownData}
                transportationDataStateChange={transportationDataStateChange}
                Transportation={transportation}
                transportationDataState={transportationDataState}
                transportationDataResult={transportationDataResult}
                pictograms={pictograms}
            ></DocumentModal>
            <MaterialSynoymsModal localizations={props.localizations} pending={pending} toggleSyns={showSynonymsModal}
                showSynsModal={showSynsModal} synonyms={synonyms} />

            <ChangeDocumentSensitivityModal modalPending={modalPending} localizations={props.localizations} toggleSensitivity={toggleSensitivity}
                showSensitivityModal={showSensitivityModal} changeSensitivityValue={changeSensitivityValue} setchangeSensitivityValue={setchangeSensitivityValue}
                submitChangeDocumentSensitivity={submitChangeDocumentSensitivity} />

            <DeleteDocumentsModal modalPending={modalPending} localizations={props.localizations} toggleDeleteDocuments={toggleDeleteDocuments}
                showDeleteDocumentsModal={showDeleteDocumentsModal} submitDeleteDocuments={submitDeleteDocuments} />

            <ArchiveDocumentsModal modalPending={modalPending} localizations={props.localizations} toggleArchiveDocuments={toggleArchiveDocuments}
                showArchiveDocumentsModal={showArchiveDocumentsModal} submitArchiveDocuments={submitArchiveDocuments} />

            <UnArchiveDocumentsModal modalPending={modalPending} localizations={props.localizations} toggleUnArchiveDocuments={toggleUnArchiveDocuments}
                showUnArchiveDocumentsModal={showUnArchiveDocumentsModal} submitUnArchiveDocuments={submitUnArchiveDocuments} />

            <EditTagsModal localizations={props.localizations} isDelete={isDelete} showEditTags={showEditTags} toggleEditTags={toggleEditTags} 
                submitEditTags={submitEditTags} TagsValue={tagsValue} changeTagsValue={changeTagsValue} tagsOptions={tagsOptions} />

        </Layout>
    );
}
